import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { OAuthService } from '../services/oauth.service';

export const LoginGuard: CanActivateFn = () => {
  const authService = inject(OAuthService);
  const router = inject(Router);

  const rootUrlTree = router.parseUrl('/');

  return authService
    .isLoggedIn()
    .pipe(switchMap((isLogged) => (isLogged ? of(rootUrlTree) : of(true))));
};
